module.exports = __webpack_public_path__ + "static/media/info_chat.cd0bbb2a.svg";